import Repository from './Repository'

const resource = '/users'

export default {
  get () {
    return Repository.get(`${resource}`)
  },
  async getList (url) {
    try {
      return await Repository.get(url)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
